

/**
 * Is the element visible (ie, occupying space in the page).
 *
 * @param {HTMLElement} $element The element to test.
 * @return {boolean} True if the element is visible, false if not.
 */
export function isVisible($element) {
    const {width, height} = $element.getBoundingClientRect();
    const occupiesSpace = width > 0 && height > 0;

    // Check computed styles for display=none or visibility=hidden.
    const style = window.getComputedStyle($element);
    const hiddenByCss = style.display === 'none' || style.visibility === 'hidden';

    return occupiesSpace && !hiddenByCss;
}
